export const GET_ALL_CHALLENGES_REQUEST = 'ChallengeListPage/GET_ALL_CHALLENGES_REQUEST';
export const GET_ALL_CHALLENGES_SUCCESS = 'ChallengeListPage/GET_ALL_CHALLENGES_SUCCESS';
export const GET_ALL_CHALLENGES_FAILURE = 'ChallengeListPage/GET_ALL_CHALLENGES_FAILURE';
export const SET_FILTERS = 'ChallengeListPage/SET_FILTERS';
